<template lang="pug">
div
  .columns.column-count-3.gap--small
    .column
      .input-wrapper2
        label.is--floating.is--active(for='ticket_date') {{i18n.date}} 
          i *
        vue-date-picker(
          v-model="form.date"
          :locale="settings.lang || 'de'"
          :enable-time-picker="false"
          :month-change-on-scroll="false"
          :auto-apply="true"
          :clearable="false"
          :start-date="startDate"
          :min-date="startDate"
          :max-date="maxDate"
          :allowed-dates="allowedDates"
          :format="format"
        )
        svg.input-icon(width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z')
        
      small * {{i18n.required}}
    .column
      .counter
        button.btn.is--icon.is--inverted(type='button' @click="form.quantity != 0 ? form.quantity-- : null")
          svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            path(d='M5.5 12.7499V11.25H18.5V12.7499H5.5Z')
        .input-wrapper
          label.is--floating.is--active(for='quantity' style="white-space:nowrap;") {{i18n.quantity}} 
            i *
          input(type='number' id='quantity' name='travel_form[quantity]' min='1' max='100' step='1' v-model="form.quantity" required)
        button.btn.is--icon.is--inverted(type='button'  @click="form.quantity++")
          svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            path(d='M11.25 12.75H5.5V11.25H11.25V5.5H12.7499V11.25H18.5V12.75H12.7499V18.5H11.25V12.75Z')
    .column
      .input-wrapper.is--select
        label.is--floating.is--active(for='package') {{i18n.package}} 
          i *
        select(id='package' name='travel_form[package]' required v-model="form.package")
          option(v-for="p in packages" :value='p') {{p}}
        svg(width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M12 15.375L6 9.37498L7.4 7.97498L12 12.575L16.6 7.97498L18 9.37498L12 15.375Z')
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker'; 
export default {
  components: {
    VueDatePicker
  },
  props: [
    "packages",
    "i18n",
    "settings",
    "form",
  ],
  data () {
    return {
      date: null,
      startDate: new Date(2024, 11, 1),
      maxDate: new Date(2025, 0, 31),
      allowedDates: [new Date(2024, 11, 1), new Date(2025, 0, 1)],
      dates: [],
      loading: true
    }
  },
  mounted () {
    const params = Object.fromEntries(new URLSearchParams(location.search));

    this.form.quantity = params.quantity || 25
    if (params.date) this.form.date = new Date(params.date+" 12:00")

    if (this.form.package) this.package = this.form.package

    this.$emit('update:buttonDisabled', true)
    this.fetchDates()
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        if (this.form.date && this.form.quantity != 0 && this.form.package && this.form.package.length != 0) {
          this.$emit('update:buttonDisabled', false)
        } else {
          this.$emit('update:buttonDisabled', true)
        }
      },
      deep: true
    }
  },
  computed: {
  },
  methods: {
    fetchDates(){
      const csrfToken = document.getElementsByName("csrf-token")[0].content
      const params = {
        count: 1,
        travel: true
      }
      const options = {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "X-CSRF-Token": csrfToken,
          "Content-Type": "application/json",
          "Accept": "application/json",
        }
      }
      fetch("/api/get/dates.json", options).then(x => x.json()).then((data) => {
        this.loading = false
        this.dates = data.dates
        this.allowedDates = data.dates.map( x => x.date )
        if (data.dates[0]){
          this.startDate = data.dates[0].date
          this.maxDate = data.dates.slice(-1).date
        }
      })
    },
    format(date){
      function pad(n, len) {
        return (new Array(len + 1).join('0') + n).slice(-len);
      }

      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${pad(day, 2)}.${pad(month, 2)}.${year}`;
    }
  }
}
</script>
